import { Color } from 'themes'

/** File for keeping our colors consistent throughout the application. */

export const REPORT_COLOR: Color = 'secondary'
export const DASHBOARD_COLOR: Color = 'tertiary'
